<template>
  <img v-if="showImage" class="chat-avatar" :src="url" :alt="name || supportName" draggable="false" @error="failed = true">
  <span v-else class="chat-avatar chat-avatar--initials" :style="palette" aria-hidden="true">{{ initials }}</span>
</template>

<script>
// Pastel background / text pairs from the design
const PALETTE = [
  ['#EAF1FF', '#2B5FD9'],
  ['#FEF3C7', '#92400E'],
  ['#E6F6F3', '#0F766E'],
  ['#F1EDFF', '#5B3FD6'],
  ['#FDEDF2', '#B4235A'],
  ['#EEF0F3', '#4B5565'],
];
const SUPPORT = ['#FFF1E8', '#C2410C'];

export default {
  name: 'ChatAvatar',
  props: {
    url: { type: String, default: '' },
    // Empty name means the Wyrel support conversation
    name: { type: String, default: '' },
    supportName: { type: String, default: 'Wyrel' },
    // Rendered diameter in px; drives the initials font size
    size: { type: Number, default: 40 },
  },
  data() {
    return { failed: false };
  },
  watch: {
    url() {
      this.failed = false;
    },
  },
  computed: {
    showImage() {
      // initials only when there is no picture at all or it failed to load
      return !!this.url && !this.failed;
    },
    initials() {
      if (!this.name) return this.supportName.charAt(0).toUpperCase();
      let parts = this.name.split(/[^\p{L}\p{N}]+/u).filter(Boolean);
      if (parts.length === 1) {
        // "SolidKeys" -> Solid|Keys, "365keys" -> 365|keys
        parts = parts[0].split(/(?=\p{Lu})|(?<=\p{N})(?=\p{L})/u).filter(Boolean);
      }
      const letters = parts.length > 1
        ? parts[0].charAt(0) + parts[1].charAt(0)
        : (parts[0] || '?').slice(0, 2);
      return letters.toUpperCase();
    },
    palette() {
      let pair = SUPPORT;
      if (this.name) {
        let hash = 0;
        for (const ch of this.name) hash = (hash * 31 + ch.codePointAt(0)) >>> 0;
        pair = PALETTE[hash % PALETTE.length];
      }
      return { background: pair[0], color: pair[1], fontSize: Math.round(this.size * 0.36) + 'px' };
    },
  },
};
</script>

<style lang="scss">
.chat-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  &--initials {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--wc-font-medium);
    font-weight: 400;
    line-height: 1;
    user-select: none;
  }
}
</style>
